<template>
  <div class="ui-kpis" role="group" :aria-label="label || null">
    <button v-for="tile in tiles" :key="tile.key" type="button" class="ui-kpi" :class="{ 'is-warn': tile.warn }" :aria-pressed="String(Boolean(tile.on))" @click="$emit('pick', tile.key)">
      <small>{{ tile.label }}</small>
      <b>{{ tile.value }}</b>
    </button>
  </div>
</template>

<script>
/** Brojke na vrhu ekrana; svaka je i filter (klik javlja ključ). tiles: [{ key, label, value, on, warn }]. */
export default {
  name: "UiKpis",
  props: {
    tiles: { type: Array, required: true },
    label: { type: String, default: "" },
  },
};
</script>
